import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import Brand from '../brand/Brand';
import { businessDetails } from '../../data/siteContent';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <Brand compact />
        <div className="footer-links">
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/privacy-policy">Privacy</Link>
        </div>
        <div className="footer-socials" aria-label="Social links">
          <a href={`https://wa.me/${businessDetails.phoneRaw}`} aria-label="WhatsApp">
            <FaWhatsapp />
          </a>
          <a href={`https://instagram.com/${businessDetails.instagram}`} aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href={`https://www.tiktok.com/@${businessDetails.tiktok}`} aria-label="TikTok">
            <FaTiktok />
          </a>
        </div>
      </div>
      <p className="footer-copy">Copyright © {year} Saqar Al-Jazeera. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
